<template>
  <div id="tab1">
    <div class="row custom-container-search">
      <filter-list :rol-name="'rol'" :user-name="'user'" />
    </div>

    <tab-item-card :status-class="'green'">
      <div slot="body">
        <div class=" d-flex jusitfy-content-between  ">
          <div class="row col-12">
            <div class="col-3 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Nombre:</span>
                <span class="data-content">Johans Cuéllar</span>
              </div>
            </div>
            <div class="custom-information-divider" />
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Usuario:</span>
                <span class="data-content">jcuellar</span>
              </div>
            </div>
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Rol:</span>
                <span class="data-content">Admin</span>
              </div>
            </div>
            <div class="col-3 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Tipo de Propuesta:</span>
                <span class="data-content">Todos</span>
              </div>
            </div>
            <div class="col-2 p-0">
              <div class="d-flex flex-column">
                <span class="data-title">Tipo de Proveedores:</span>
                <span class="data-content">Todos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="actions">
        <action-button
          class="fr px-4 custom-btn-remove"
          i="fa fa-times-circle"
          text="Remover"
        />
      </div>
    </tab-item-card>
    <pagination class="custom-pagination" />
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import TabItemCard from './TabItemCard';
import Pagination from '@/components/common/Pagination';
import FilterList from './FilterList';

export default {
  name: 'Tab1',

  components: {
    ActionButton,
    TabItemCard,
    Pagination,
    FilterList,
  },
};
</script>

<style scoped>
.custom-search-button {
  float: right;
}

.custom-drop-down {
  width: 100%;
}

.custom-container-search {
  background: #f2f2f2;
  padding: 10px 5px;
  width: 99.6%;
  margin-left: 2px;
}

.custom-information-container {
  float: left;
  width: 100%;
  margin-top: 20px;
}

.custom-information {
  float: left;
}

.custom-information-data {
  background: #f2f2f2;
  float: left;
  padding: 25px 0px 25px 0px;
  border-left: 4px solid #2db782;
  border-radius: 5px;
}

.vgt-wrap {
  float: left;
  width: 100%;
}

.tag-badge-info {
  display: none !important;
}

.custom-information p {
  margin-bottom: 5px;
  font-size: 15px;
  color: #727272;
  font-weight: normal;
}

.custom-btn-remove {
  border: 1px solid #c5525c;
  color: #c5525c;
  background: none;
  margin-top: 8px;
}

.custom-btn-remove:hover {
  background-color: #c5525c;
  border: 1px solid #c5525c;
  color: #fff;
}

.custom-information-divider {
  float: left;
  background: #72727230;
  width: 2px;
  height: 55px;
  position: absolute;
  margin-left: 160px;
}

.custom-pagination {
  float: left;
  width: 100%;
}

@media (max-width: 768px) {
  .custom-information-divider {
    margin-left: 96px !important;
  }
}

@media (max-width: 1024px) {
  .custom-information-divider {
    margin-left: 130px;
  }

  .custom-drop-down {
    width: 80%;
  }
}

data-title {
  text-align: left;
  font: 400 14px/28px Lato;
  letter-spacing: 0;
  color: #727272;
  word-break: break-word;
  overflow-wrap: break-word;
}
.data-content {
  text-align: left;
  font: 400 16px/28px Lato;
  letter-spacing: 0;
  color: #11291b;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
